/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {ReportTemplateListPageComponent} from './report-template-list-page.component';

@Component({
  standalone: true,
  imports: [ReportTemplateListPageComponent],
  selector: 'adn-report-template-route-page',
  template: `
    <adn-report-template-list-page
      [readOnly]="readOnly">
    </adn-report-template-list-page>
  `
})
export class ReportTemplateRoutePageComponent {
  @Input() readOnly = false;
}
